import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { emitDatadogError } from "@faire/web--source/common/datadog/rum";
import { isLocal } from "@faire/web--source/common/user-agent/isLocal";
import { isStaging } from "@faire/web--source/common/user-agent/isStaging";
var logException = function(level) {
    return function(error, options) {
        if (options === null || options === void 0 ? void 0 : options.serverOnly) {
            // TODO: FD-176705 - log exceptions without the use of globals.
            // (we can't `getGlobalProperty` from server components)
            return;
        }
        var optionsWithLevel = _object_spread_props(_object_spread({}, options !== null && options !== void 0 ? options : {}), {
            level: level
        });
        // eslint-disable-next-line @faire-web/no-restricted-globals
        if ("object" === "undefined") {
            import("@faire/web--source/common/serverLogging").then(function(param) {
                var log = param.default;
                if (level === "fatal" || level === "error") {
                    log.error(error, optionsWithLevel);
                } else if (level === "warning") {
                    log.warn(error, optionsWithLevel);
                } else {
                    log.info(error, optionsWithLevel);
                }
            });
        } else {
            emitDatadogError(error, optionsWithLevel);
        }
    };
};
export var logFatal = logException("fatal");
export var logError = logException("error");
export var logWarning = logException("warning");
export var logInfo = logException("info");
export var logAssert = function(condition, message, options, reporter) {
    if (!condition) {
        var msg = "".concat(reporter ? "".concat(reporter, ": ") : "").concat(message);
        var error = new Error(msg);
        logError(error, options !== null && options !== void 0 ? options : {});
        if (isLocal() || isStaging()) {
            throw error;
        }
    }
};
